import styled from 'styled-components'
import { colors } from 'styles/template/variables'

interface ImagePreviewProps {
  imageUrl: string,
  width?: number;
  height?: number;
}

interface SellerNicknameProps {
  textColor?: 'black' | 'white';
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
` 

export const Content = styled.div`
  flex: 1;

  &+div{
    margin-left: 2rem;
  }
`

export const CardContent = styled.div`
  display: flex;

  div{
    &+div{
      margin-left: 1rem;
    }
  }
` 

export const ImageContainer = styled.div`
  min-width: 156px;
  max-width: 156px;
  height: 156px;
  overflow: hidden;
  border-radius: 16px;
  img {
    width: auto;
    height: 156px;
    position: relative;
    left: -50%;
  }
`

export const LogoCard = styled.div`
  display: flex;
`

export const ImageDetails = styled.div`
  padding: 36px;
`

export const PreviewBackgound = styled.div.attrs(props => ({
  style: {
    backgroundColor: props.color,
  },
}))`
  padding-top: 48px;
  padding-bottom: 48px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;

  * {
    margin-top: 4px;
    margin-bottom: 4px;
  }
`

export const ImagePreview = styled.div<ImagePreviewProps>`
  min-width: ${props => props.width ?? 80}px;
  max-width: ${props => props.width ?? 80}px;
  height: ${props => props.height ?? 80}px;
  background-color: ${colors.gray100};
  border-radius: 16px;
  background-image: url('${props => props.imageUrl}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center; 
`

export const SellerNickname = styled.h3<SellerNicknameProps>`
  color: ${props => props.textColor ?? 'white'};
`

export const ExternalLink = styled.div`
  padding: 8px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.5);
  font-weight: 700;
  font-size: 14px;
`